import { Block } from '@components/Layout';
import { FC } from 'react';

import dynamic from 'next/dynamic';

const Video = dynamic(() => import('@components/Video'), { ssr: false });

import { VideoWrapper } from '../styles';

export interface VideoPlayerProps {
  header?: string;
  video_source?: boolean;
  youTubeUrl?: string;
  videoUpload?: string;
  posterImage?: string;
}

const VideoPlayer: FC<VideoPlayerProps> = ({
  header,
  video_source,
  youTubeUrl,
  videoUpload,
  posterImage,
}) => {
  return (
    <Block>
      <h2 className="visually-hidden">{header}</h2>
      <VideoWrapper>
        <Video
          video_source={video_source}
          youTubeUrl={youTubeUrl}
          videoUpload={videoUpload}
          posterImage={posterImage}
          controls={true}
        />
      </VideoWrapper>
    </Block>
  );
};

export default VideoPlayer;
